import { Injectable } from '@angular/core';
import {
  HttpContextToken,
  HttpInterceptor,
  HttpEvent,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { BusyBarService } from './busy-bar.service';

/**
 * Opts one request out of the global busy bar. For bulk transfers that issue
 * hundreds of requests — a 4 GB chunked upload is over a thousand — where an
 * indicator that never clears says less than the feature's own progress does.
 */
export const SKIP_BUSY_BAR = new HttpContextToken<boolean>(() => false);

@Injectable()
export class BusyInterceptor implements HttpInterceptor {
  constructor(private readonly _busyBarService: BusyBarService) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.context.get(SKIP_BUSY_BAR)) {
      return next.handle(req);
    }
    const msg = req.method === 'GET' ? 'Loading ...' : 'Saving ...';
    this._busyBarService.increment(msg);
    return next
      .handle(req)
      .pipe(finalize(() => this._busyBarService.decrement()));
  }
}
